import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';
import { THEME } from 'src/styles/theme';

type ContainerProps = {
  maxHeight?: boolean;
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${(props: ContainerProps) => (props.maxHeight ? '100vh' : 'auto')};
`;

type Props = {
  title?: string;
  maxHeight?: boolean;
};

const Loader = ({ title = '', maxHeight = false }: Props) => (
  <Container maxHeight={maxHeight}>
    <CircularProgress
      variant="indeterminate"
      size={100}
      sx={{
        color: THEME.main.primary,
      }}
    />
  </Container>
);

export default Loader;
